
import { defineComponent, getCurrentInstance, ref, computed } from "vue";
import { useStore } from 'vuex';
import { useRouter } from "vue-router";
import image from "@/assets/images/user.png";

export default defineComponent({
  data: function () {
    return {
      navItems: [
        { id: 1, name: "viewDashboard", label: "Dashboard", icon: "xr-icon-dashboard", route: "/dashboard" },
        { id: 2, name: "viewGamesList", label: "Games", icon: "xr-icon-game", route: "/games" },
        { id: 3, name: "viewTokensList", label: "Tokens", icon: "xr-icon-token", route: "/tokens" },
        { id: 4, name: "viewHomeSettings", label: "Settings", icon: "xr-icon-settings", route: "/settings" },
        // { id: 5, name: "", label: "Revenue", icon: "xr-icon-revenue", route: "/revenue" },
        // { id: 6, name: "", label: "Metrics", icon: "xr-icon-group", route: "/metrics" },
      ],
      rt: this.$route.fullPath,
    };
  },
  setup(){
    const internalInstance = getCurrentInstance();
    const emitter = internalInstance.appContext.config.globalProperties.emitter;
    const store = useStore();
    const router = useRouter();

    const logout = () => {
      store.dispatch('auth/removeStates');
      sessionStorage.removeItem('tourl');
      router.push({ path: '/login' });
    }

    let userObj = store.getters['auth/user'];
    const username = ref(userObj.username);

    const setDropDown = () => {
      if(window.innerWidth < 900){
        store.dispatch('config/setDropDown', false);
      }
    }

    const createNewGame = () => {
      emitter.emit("OPEN_CREATE_NEW_GAME_MODAL", true);
      return false;
    }

    const assetUrl = computed(() => {
      return store.getters['config/assetUrl'];
    });

    const image = computed(() => {
      return (userObj.profilePicture)?assetUrl.value + 'blob/users/' + userObj.username + '/' + userObj.profilePicture:image;
    });

    emitter.on('REFRESH_PROFILE_PHOTO', (payload) => {
      if(payload){
        userObj = store.getters["auth/user"];
      }
    });

    return {
      logout,
      username,
      setDropDown,
      createNewGame,
      image,
    }
  }
 });
